import { INITIAL_AVAILABILITY_FILTERS_CONTEXT } from '@winelidays/wld-tsx-2/constants';
import { createContext } from 'react';
const AvailabilityFiltersContext = createContext(INITIAL_AVAILABILITY_FILTERS_CONTEXT);
export default AvailabilityFiltersContext;
